import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[grid-header-top-action-template]' })
export class GridHeadeTopActionTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
